<template>
  <v-dialog :value="visible" width="660" content-class="rounded-xl" @input="$emit('input', $event)" persistent>
    <v-sheet class="py-6 px-8">
      <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">얼리 제품 수정하기</p>

      <v-sheet class="mt-2 px-4">
        <v-text-field class="rounded-10" label="이름" dense outlined v-model="updateItem.productName"></v-text-field>

        <!-- 컨셉 선택 -->
        <v-select
          class="mb-4"
          outlined
          dense
          hide-details
          :items="conceptList"
          v-model="updateItem.concept"
          item-text="title"
          label="컨셉"
          :return-object="true"
          :key="'concept' + conceptSelectKey"
        ></v-select>

        <!-- promomotion code 선택 -->
        <SelectedPromotions :promotions="updateItem.promotionCodesArr" @addPromotion="visiblePromotionSelect = true" />

        <v-text-field class="rounded-10 mt-6" label="한줄 설명" dense outlined v-model.trim="updateItem.subTitle"></v-text-field>

        <v-text-field class="rounded-10 mt-2" label="Base 금액" dense outlined v-model.number="updateItem.baseAmount" type="number" hide-spin-buttons></v-text-field>

        <div class="font-weight-bold text-body-1 py-2">유효 기간</div>
        <v-row>
          <v-menu v-model="startAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="updateItem.startAtDate" label="시작일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
            </template>
            <v-date-picker v-model="updateItem.startAtDate" no-title scrollable color="green" @input="startAtMenu = false"></v-date-picker>
          </v-menu>
          <v-menu v-model="endAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="updateItem.endAtDate" label="종료일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
            </template>
            <v-date-picker v-model="updateItem.endAtDate" no-title scrollable color="warning" @input="endAtMenu = false"> </v-date-picker>
          </v-menu>
        </v-row>

        <!-- 상품 설명 페이지 -->
        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
          <TipTapWriter class="tiptap_style mt-2" :options="options" :key="'ko' + componentKey" />
        </v-sheet>

        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
          <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en' + en.componentKey" />
        </v-sheet>

        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">일어</div>
          <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp' + jp.componentKey" />
        </v-sheet>

        <v-sheet class="d-flex justify-center mt-5">
          <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('input', false)">
            <v-icon small left>mdi-cancel</v-icon>
            취소하기
          </v-btn>
          <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="submit()">
            <v-icon small left>mdi-database-plus-outline</v-icon>
            수정하기
          </v-btn>
        </v-sheet>
      </v-sheet>

      <PromotionSelect :visible="visiblePromotionSelect" @input="(e) => (visiblePromotionSelect = e)" @add="addPromotion" />
    </v-sheet>
  </v-dialog>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import SelectedPromotions from "./SelectedPromotions"
import PromotionSelect from "./PromotionSelect"

export default {
  components: {
    TipTapWriter,
    SelectedPromotions,
    PromotionSelect,
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    item: {
      type: Object,
      require: true,
    },
  },
  inject: ["promotions"],

  data: () => ({
    updateItem: {},
    startAtMenu: false,
    endAtMenu: false,

    conceptList: [],
    conceptSelectKey: 0,
    visiblePromotionSelect: false,

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
  }),

  mounted() {
    if (!this.item) {
      return
    }
    console.log("mounted", this.item)
    console.log("codes", this.item.promotionCodes.split(","))
    const itemPromotionCodes = this.item.promotionCodes.split(",")
    this.promotions.filter((p) => itemPromotionCodes.includes(p.code))
    this.updateItem = {
      ...this.item,
      promotionCodesArr: this.promotions.filter((p) => itemPromotionCodes.includes(p.code)),
      concept: null,
      startAtDate: this.dayjs(this.item.startAt).format("YYYY-MM-DD"),
      endAtDate: this.dayjs(this.item.endAt).format("YYYY-MM-DD"),
    }

    this.options.content = this.updateItem.content
    this.en.options.content = this.updateItem.content_en
    this.jp.options.content = this.updateItem.content_jp

    this.componentKey++
    this.en.componentKey++
    this.jp.componentKey++

    this.$http
      .post("/api/concept/select/search", {
        params: {
          keyword: "",
        },
      })
      .then((res) => {
        this.conceptList = res.data
        this.updateItem.concept = this.conceptList.find((e) => e.id === this.item.conceptId)
        this.conceptSelectKey++
      })
  },

  methods: {
    submit: _.debounce(async function () {
      console.log("selected concept", this.updateItem.concept)
      if (this.updateItem.productName == "") {
        alert("상품명을 입력해 주세요")
        return
      }
      if (this.updateItem.promotionCodes.length === 0) {
        alert("프로모션 코드를 선택해 주세요")
        return
      }
      if (!this.updateItem.startAtDate) {
        alert("시작일자를 입력해 주세요")
        return
      }
      if (!this.updateItem.endAtDate) {
        alert("종료일자를 입력해 주세요")
        return
      }

      if (!this.updateItem.subTitle) {
        alert("상품 설명을 입력해 주세요")
        return
      }

      try {
        const res = await this.$http.post("/api/early/admin/update", {
          productName: this.updateItem.productName,
          promotionCodes: this.updateItem.promotionCodesArr.map((e) => e.code).join(","),
          conceptId: this.updateItem.concept.id,
          conceptName: this.updateItem.concept.title,
          subTitle: this.updateItem.subTitle,
          startAt: this.updateItem.startAtDate,
          endAt: this.updateItem.endAtDate,
          baseAmount: this.updateItem.baseAmount,
          description: this.options.content,
          description_en: this.en.options.content,
          description_jp: this.jp.options.content,
          id: this.updateItem.id,
        })
        this.$toast.success("상품이 정상적으로 수정되었습니다.")
        this.$emit("complete")
      } catch (e) {
        console.log(e)
        alert("등록되지 않았습니다")
      }
    }, 500),

    addPromotion(promotion) {
      console.log("addPromotion")
      const found = this.updateItem.promotionCodesArr.find((e) => e.id == promotion.id)
      if (found) {
        this.$toast.error("이미 등록되었습니다.")
        return
      }
      this.updateItem.promotionCodesArr.push(promotion)
    },
  },
}
</script>
<style></style>
